import { LeftOutlined } from '@ant-design/icons';
import { colors } from 'design';
import { createUseStyles } from 'react-jss';

export type BackButtonProps = {
  onClick: () => void;
};

const useStyles = createUseStyles({
  button: {
    cursor: 'pointer',
    pointerEvents: 'auto',
    fontSize: 22,
    color: colors.text.primary,
    display: 'flex',
    alignItems: 'center',
  },
});

export default function BackButton(props: BackButtonProps) {
  const { onClick } = props;

  const styles = useStyles();

  return (
    // `aria-label` kept identical to the old `<Image alt="back-button">` — the
    // functional suite locates this button by that exact accessible name
    // (`get_by_role("img", name="back-button")`) in ~20 places.
    <LeftOutlined aria-label="back-button" className={styles.button} onClick={() => onClick()} />
  );
}
